import React, { useEffect  } from "react";
import { useTenant } from "./whitelabel/useTenant";
import { LayoutProvider } from "./context/LayoutContext";
import AppContent from "./components/AppContent/AppContent";
import { ThemeProvider } from "./context/ThemeContext";
import '../src/index.css'
import $ from 'jquery';
import moment from 'moment';
import { SnackbarProvider } from "./components/MUIComponent/FeedbackComponent/SnackBar/SnackbarContext";
// Make jQuery and moment available globally (required for daterangepicker)
window.$ = $;
window.jQuery = $;
window.moment = moment;

const App = () => {
  const tenant = useTenant();

  return (
    <>
      <ThemeProvider>
        <SnackbarProvider>
        <LayoutProvider>
          <AppContent tenant={tenant} />
        </LayoutProvider>
        </SnackbarProvider>
      </ThemeProvider>


      {/* <Toaster
        position="top-right"
        reverseOrder={false}
        containerStyle={{
          zIndex: 25000,
        }}
      /> */}
    </>
  );
};

export default App;
